import {
  WORKSPACE_FOR_TRACE_QUERY,
  type WorkspaceForTraceResult
} from '@/gql/queries/workflow-cards.gql';
import { useWorkspaceFromQuery } from '@/hooks/useWorkspaceFromQuery';

// The trace inspector resolves a trace by its raw UUID via the `traceById`
// query (matching how `traceInspector` loads it), not the Relay node id.
export const useWorkspaceForTrace = (traceId: string) =>
  useWorkspaceFromQuery<WorkspaceForTraceResult, { traceId: string }>({
    query: WORKSPACE_FOR_TRACE_QUERY,
    id: traceId,
    variables: { traceId },
    select: data => data?.traceById?.workflow?.workspace ?? null
  });
